import { toggleItems } from '@src/components/toggleItems';

document.addEventListener('DOMContentLoaded', function (_event) {
  const $items = $('.integrations-list-section .toggle-item');

  toggleItems($items, false, false);
});
